export default __webpack_public_path__ + "static/media/IG.46034e33.png";